module.exports = __webpack_public_path__ + "static/media/snowflake_1.dd422e14.png";